import { useSearchParams } from 'react-router-dom';
import { Icons } from '@/utils/Icons';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import { ForgotPasswordForm } from './ForgotPassword';
import { useLockBodyScroll } from '@/hooks';
import { createPortal } from 'react-dom';

export default function AuthModal() {
  const [searchParams, setSearchParams] = useSearchParams();

  const mode = searchParams.get('mode');
  const isOpen = !!mode;

  useLockBodyScroll(isOpen);

  if (!isOpen) return null;

  const updateParams = (value?: string) => {
    const params = new URLSearchParams(searchParams);

    if (value) params.set('mode', value);
    else params.delete('mode');

    setSearchParams(params);
  };

  const handleClose = () => updateParams();

  return createPortal(
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/70">
      <div className="w-full max-w-[800px] rounded-[20px] overflow-hidden grid lg:grid-cols-12 bg-[#1c1d25]">
        {/* LEFT */}
        <div className="hidden lg:block lg:col-span-6">
          <div className="relative h-full p-[3px] rounded-l-[20px]">
            <img src="/images/auth-bg.jpg" className="w-full h-full object-cover rounded-[27px]" />
            <img
              src="/logo.png"
              className="absolute top-[30px] left-1/2 -translate-x-1/2 w-[30%]"
            />
          </div>
        </div>

        {/* RIGHT */}
        <div className="lg:col-span-6 bg-[#1c1d25] rounded-r-[20px] relative max-h-[90vh] overflow-y-auto px-[15px] scrollbar-hide">
          <button onClick={handleClose} className="absolute top-4 right-4 text-white/70">
            <Icons.Close className="font-bold" />
          </button>

          {mode === 'login' && (
            <LoginForm onSwitch={(m) => updateParams(m)} onClose={handleClose} />
          )}

          {mode === 'forgot' && (
            <ForgotPasswordForm onSwitch={() => updateParams('login')} onClose={handleClose} />
          )}

          {mode === 'register' && (
            <RegisterForm onSwitch={(m) => updateParams(m)} onClose={handleClose} />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
